import React from 'react';
import { CloseIcon, SearchIcon } from '../icons';
import { useThemeColor } from '../Theme';
import { useTranslate } from '../util';
import { StyledClearIconButton } from './SearchInput.styled';
import { TextInput } from './TextInput';
export function SearchInput(props) {
  var t = useTranslate();
  var textIconColor = useThemeColor('secondaryText');
  var style = {
    width: props.width
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "search",
    id: props.id,
    maxLength: props.maxLength,
    autoFocus: props.autoFocus,
    placeholder: props.placeholder,
    hint: props.hint,
    value: props.value,
    disabled: props.disabled,
    onChange: props.onChange,
    inputRef: props.inputRef,
    icon: /*#__PURE__*/React.createElement(SearchIcon, {
      size: 16,
      color: textIconColor
    }),
    secondaryIcon: props.value ? /*#__PURE__*/React.createElement(StyledClearIconButton, {
      icon: CloseIcon,
      onClick: clearInput,
      size: 16,
      title: t('citrix-ui:clear_search')
    }) : undefined
  }));
  function clearInput() {
    props.onChange && props.onChange('');
  }
}